var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-border-circle-medium"},[_c('button',{class:[{'no-editing-permission':!_vm.editingPermission},'btn', 'btn-' + _vm.color],style:(_vm.buttonStyle),attrs:{"type":"button","disabled":_vm.disabled}},[_vm._v(" "+_vm._s(_vm.labelName)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }